/**
 * Extracts error message from API response
 * Handles different error response formats from the server
 * 
 * @param {Object} err - The error object from API call
 * @returns {string} - Formatted error message
 */
export const extractErrorMessage = (err) => {
  let errorMessage = "An error occurred";
  
  if (err.response && err.response.data) {
    // First try to get the general message
    if (err.response.data.message) {
      errorMessage = err.response.data.message;
    }
    
    // If there are validation errors, get the first one
    if (err.response.data.errors && typeof err.response.data.errors === 'object') {
      const firstFieldKey = Object.keys(err.response.data.errors)[0];
      if (firstFieldKey && Array.isArray(err.response.data.errors[firstFieldKey]) && err.response.data.errors[firstFieldKey][0]) {
        errorMessage = err.response.data.errors[firstFieldKey][0];
      } else if (firstFieldKey && typeof err.response.data.errors[firstFieldKey] === 'string') {
        errorMessage = err.response.data.errors[firstFieldKey];
      }
    }
    
    // Handle cases where errors might be an array directly
    if (Array.isArray(err.response.data.errors) && err.response.data.errors[0]) {
      errorMessage = err.response.data.errors[0];
    }
  }
  
  return errorMessage;
};
